import { Box, Image, Text, useMediaQuery, Flex } from "@chakra-ui/react";

interface TxtComponentProps {
  companyLogo?: string | null;
}

const TxtComponent = ({ companyLogo }: TxtComponentProps) => {
  const [isMobile] = useMediaQuery("(max-width: 480px)");
  const [isTab] = useMediaQuery("(max-width: 768px)");

  return (
    <Box>
      {/* Left side with logo and description */}
      <Box p={isMobile ? "0px":  "8px"} marginLeft="0px" textAlign={"left"}>
        {!isMobile && !isTab && (
          <Flex alignItems="center" gap="20px" mb="40px">
            <Image
              width={"60%"}
              src="/Images/poco-care-text-logo.png"
              alt="PocoCare Logo"
            />  
            {companyLogo && (
              <Image
                maxH="80px"
                src={companyLogo}
                alt="Partner Company Logo"
              />
            )}
          </Flex>
        )}
        
        <Text
          color="#333"
          fontSize={isMobile ? "9px" : "16px"}
          fontFamily="Poppins"
          fontWeight="500"
          lineHeight={isMobile ? "15px" : "26px"}
          letterSpacing="0.06em"
          fontStyle="normal"
          mb={isMobile ? "0px" : "2px"}
        >
          Buy{' '}
          <Text
            as="span"
            display="inline"
            fontWeight="900"
            fontFamily="Poppins"
            fontSize={isMobile ? "12px" : "18px"}   // 👈 slightly larger
          >
            Pococare
          </Text>{' '}
          subscription and give your family the assurance of peace of mind and the fastest medical emergency assistance.
        </Text>
        {/* <Text
          color="#333"
          fontSize={isMobile ? "9px" : "16px"}
          fontFamily="Poppins"
          fontWeight="500"
          lineHeight={isMobile ? "15px" : "26px"}
          letterSpacing="0.06em"
          fontStyle="normal"
          mb={isMobile ? "0px" : "2px"}
        >
          "Incident to Hospital Admission"
          <br />
          Service Anytime
        </Text>
        <Text
          color="#333"
          fontSize={isMobile ? "7px" : "12px"}
          fontFamily="Poppins"
          fontWeight="400"
          lineHeight={isMobile ? "15px" : "26px"}
          letterSpacing="0.06em"
          fontStyle="normal"
        >
          “Peace of Mind for you and your family”
        </Text> */}
      </Box>
    </Box>
  );
};

export default TxtComponent;
